
import { computed, PropType, Ref } from 'vue';
import { useStore } from 'vuex';
import { ToastVariant } from '@/store/ui/types';

export default {
  name: 'Toast',
  props: {
    message: String,
    variant: {
      type: String as PropType<ToastVariant>,
      default: 'error',
    },
  },
  setup(props: { message: string }): { errorMessage: Ref<string>; clearToast: () => Promise<void> } {
    const store = useStore();
    const errorMessage: Ref<string> = computed(() => props.message);

    const clearToast = () => store.dispatch('ui/clearErrorMessage');

    return {
      errorMessage,
      clearToast,
    };
  },
};
